module.exports = __webpack_public_path__ + "img/banner4-3.bfee59e7.png";